<template>
  <div>
    <div class="mine-box-title">{{ $T('修改密码') }}</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="180px"
          class="demo-ruleForm"
          :rules="formRules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('当前密码')" prop="old_password">
              <el-input
                  type="password"
                  autocomplete="current-password"
                  :placeholder="$T('请输入当前密码')"
                  v-model="formData.old_password"
                  show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('新密码')" prop="password">
              <el-input
                  type="password"
                  autocomplete="new-password"
                  :placeholder="$T('请输入新密码')"
                  v-model="formData.password"
                  show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$T('确认新密码')" prop="password2">
              <el-input
                  type="password"
                  autocomplete="new-password"
                  :placeholder="$T('请再次输入新密码')"
                  v-model="formData.password2"
                  show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">{{ $T('确定') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>

      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>

</template>
<style scoped>
.btn {
  padding: 0 0.3rem;
  margin-top: 0.3rem;
}

.mine-box-title {
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 33px;
  margin-bottom: 13px;
}

</style>

<script>
import {Toast} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: 'Password',
  components: {
    Toast, LoginDialog
  },
  data: function () {
    return {
      saveLoading: false,
      loginShow: false,
      formData: {
        old_password: '',
        password: '',
        password2: '',
      },
      loading: false
    }
  },
  computed: {
    formRules() {
      const vm = this;
      return {
        old_password: [
          { required: true, message: this.$T('请输入当前密码'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$T('请输入新密码'), trigger: 'blur' },
          { min: 6, message: this.$T('新密码至少6位'), trigger: 'blur' },
        ],
        password2: [
          { required: true, message: this.$T('请再次输入新密码'), trigger: 'blur' },
          {
            validator(rule, value, callback) {
              if (value !== vm.formData.password) {
                callback(new Error(vm.$T('两次新密码不一致')));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      };
    },
  },
  mounted() {
    document.title = this.$T('修改密码')
  },
  destroyed() {
  },
  methods: {
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
    },

    loginCancel() {
      console.log('-------取消登录--------');
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          that.$api.post('/api/user/editPassword', {
            old_password: that.formData.old_password,
            password: that.formData.password,
            password2: that.formData.password2,
          }, (res) => {
            that.$message.success(that.$T('密码修改成功'))
            rbLink({
              name: 'MineIndex'
            })
            that.saveLoading = false;
          }, (res) => {
            if (res.code == 401 || res.code == 402) {
              that.loginShow = true
            } else {
              const msg = res.msg || '';
              if (msg) {
                Toast(that.$T(msg));
              }
            }
            that.saveLoading = false;
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>



// WEBPACK FOOTER //
// Password.vue?21cdb65c